import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ArrowRightIcon, TimerIcon } from 'lucide-react';
import { TrustBadges } from './TrustBadges';
export function ClosingLP4() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-24 px-4 bg-navy relative overflow-hidden" data-id="element-40">
      {/* Background elements */}
      <div className="absolute inset-0 bg-gradient-to-t from-navy-dark via-navy to-navy pointer-events-none" data-id="element-41" />
      <motion.div animate={{
      scale: [1, 1.1, 1],
      opacity: [0.1, 0.2, 0.1]
    }} transition={{
      duration: 5,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/20 rounded-full blur-[100px] pointer-events-none" data-id="element-42" />

      <div className="max-w-3xl mx-auto relative z-10 text-center" data-id="element-43">
        <motion.div initial={{
        opacity: 0,
        y: 50
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 50
      }} transition={{
        duration: 0.8
      }} data-id="element-44">
          <div className="inline-flex items-center justify-center p-3 bg-gold/10 rounded-full mb-6 border border-gold/30" data-id="element-45">
            <TimerIcon className="h-8 w-8 text-gold" data-id="element-46" />
          </div>

          <h2 className="font-heading font-black text-4xl md:text-5xl lg:text-6xl mb-8 text-white" data-id="element-47">
            Empieza a Ganar <span className="text-gold" data-id="element-48">Esta Semana</span>
          </h2>

          <div className="space-y-6 font-body text-lg md:text-xl text-gray-300 mb-12 leading-relaxed" data-id="element-49">
            <p data-id="element-50">
              El mercado de los negocios locales está desesperado por ayuda
              digital, y la Inteligencia Artificial ha nivelado el campo de
              juego. Ya no necesitas ser una agencia costosa para ofrecer
              resultados de primer nivel.
            </p>
            <p className="font-bold text-white" data-id="element-51">
              Pero este precio de lanzamiento de $27 no durará para siempre.
            </p>
            <p data-id="element-52">
              Agenda tu llamada ahora, asegura tu acceso al sistema completo y
              descubre cómo la IA puede construir tu próximo negocio rentable.
            </p>
          </div>

          <motion.a href="/checkout-2" onClick={() => {
          if ((window as any).fbq) (window as any).fbq('track', 'AddToCart', {
            content_name: 'AI Web Closer Course',
            content_type: 'product',
            value: 27,
            currency: 'USD'
          });
        }} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-flex group bg-gold hover:bg-gold-light text-navy font-heading font-black text-xl md:text-2xl px-10 py-6 rounded-2xl shadow-2xl shadow-gold/20 transition-all duration-300 items-center justify-center gap-4 w-full sm:w-auto" data-id="element-53">
            QUIERO ACCESO POR $27
            <ArrowRightIcon className="h-7 w-7 group-hover:translate-x-2 transition-transform" aria-hidden="true" data-id="element-54" />
          </motion.a>

          <TrustBadges data-id="element-55" />
        </motion.div>
      </div>
    </section>;
}